import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiQuery } from '@app/core/http/api-query';
import { Observable } from 'rxjs';
import { PaginatedResponse } from '@app/shared/models/paginated-response.model';
import { map } from 'rxjs/operators';
import { HttpResponse } from '@app/core';
import { Model } from '@app/shared/models/model.model';
import { Reminder } from '@app/reminders/reminders/reminder.model';
import { ResourceInterface } from '@app/shared/models/resource.interface';

@Injectable({
  providedIn: 'root',
})
export class RemindersService implements ResourceInterface {
  constructor(private http: HttpClient) {}

  index(query: ApiQuery = new ApiQuery()): Observable<PaginatedResponse> {
    return this.http.get('v1/reminders', query.buildGetOptions()).pipe(
      map((response: HttpResponse) => {
        response.data = response.data.map((reminder: any) => {
          return new Reminder().deserialize(reminder);
        });

        return new PaginatedResponse().deserialize(response);
      })
    );
  }

  update(reminder: Reminder): Observable<Reminder> {
    return this.http.put('v1/reminders/' + reminder.id, reminder).pipe(
      map((response: HttpResponse) => {
        return new Reminder().deserialize(response.data);
      })
    );
  }

  store(reminder: Reminder): Observable<Reminder> {
    return this.http.post('v1/reminders', reminder).pipe(
      map((response: HttpResponse) => {
        return new Reminder().deserialize(response.data);
      })
    );
  }

  show(id: number, query: ApiQuery = new ApiQuery()): Observable<Model> {
    return this.http.get('v1/reminders/' + id, query.buildGetOptions()).pipe(
      map((response: HttpResponse) => {
        return new Reminder().deserialize(response.data);
      })
    );
  }

  destroy(id: number): Observable<any> {
    return this.http.delete('v1/reminders/' + id);
  }
}
